// v2/utils/adminFormat.js — yonetim paneli ortak bicimlendiricileri
const TZ = 'Europe/Istanbul';

const gunAnahtari = (d) => d.toLocaleDateString('tr-TR', { timeZone: TZ });
const yilAnahtari = (d) => d.toLocaleDateString('tr-TR', { timeZone: TZ, year: 'numeric' });

/** ISO zaman -> "Bugün 18:54" | "16.09 18:54" | "04.05.2025 11:44" */
export function zamanTR(iso) {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  const simdi = new Date();
  const saat = d.toLocaleTimeString('tr-TR', { timeZone: TZ, hour: '2-digit', minute: '2-digit' });
  if (gunAnahtari(d) === gunAnahtari(simdi)) return `Bugün ${saat}`;
  const ayniYil = yilAnahtari(d) === yilAnahtari(simdi);
  const tarih = d.toLocaleDateString('tr-TR', {
    timeZone: TZ, day: '2-digit', month: '2-digit', ...(ayniYil ? {} : { year: 'numeric' }),
  });
  return `${tarih} ${saat}`;
}

function yerelTarih(ymd) {
  const [y, m, g] = String(ymd || '').split('-').map(Number);
  if (!y || !m || !g) return null;
  return new Date(y, m - 1, g);
}

/** "2026-09-17" -> "17.09" */
export function gunKisa(ymd) {
  const d = yerelTarih(ymd);
  if (!d) return '';
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/** "2026-09-17" -> "17 Eylül Perşembe" */
export function gunUzun(ymd) {
  const d = yerelTarih(ymd);
  return d ? d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', weekday: 'long' }) : '';
}

/** "Ali Veli Avcı" -> "AA" */
export function basHarfler(ad) {
  const p = String(ad || '').trim().split(/\s+/).filter(Boolean);
  if (!p.length) return '?';
  const ilk = p[0][0] || '';
  const son = p.length > 1 ? p[p.length - 1][0] || '' : '';
  return (ilk + son).toLocaleUpperCase('tr-TR');
}

export const DEPO_ETIKET = {
  GZT: 'Gaziantep',
  IST: 'İstanbul',
  MIX: 'Gaziantep + İstanbul',
};

export const SIPARIS_DURUM = {
  transferred: { label: 'Aktarıldı', cls: 'stOk' },
  processing: { label: 'İşlemde', cls: 'stWait' },
  error: { label: 'Hata', cls: 'stErr' },
};
